<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="出库类型" prop="type">
              <RadioGroup v-model="formData.type" class="perW30" @on-change="selectType">
                <Radio :label="2">三方出库</Radio>
                <Radio :label="1">基地出库</Radio>
              </RadioGroup>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="出库仓库" prop="warehouse_id">
              <Select v-model="formData.warehouse_id" placeholder="请选择出库仓库" class="perW30" @on-change="selectWarehouse">
                <Option v-for="(name, id) in warehouseList" :value="id" :key="id">{{ name }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="入库单" prop="warehouse_inventory_in_id">
              <Select v-model="formData.warehouse_inventory_in_id" placeholder="请选择入库单" class="perW30" @on-change="selectWarehouseInventoryIn">
                <Option v-for="(item, key) in warehouseInventoryInList" :value="item.warehouse_inventory_in_id" :key="item.warehouse_inventory_in_id">{{ item.warehouse_inventory_in_sn }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="库存物品" prop="num">
              <Input v-model="warehouseInventoryInData.goods_name" disabled class="perW30"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="库存数量" prop="num">
              <Input v-model="warehouseInventoryInData.num" disabled class="perW20"></Input>
              <span> {{warehouseInventoryInData.unit}}</span>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="出库数量" prop="out_num">
              <InputNumber :disabled="formData.type === 2" v-model="formData.out_num" :min="0" class="perW20"></InputNumber>
              <span> {{warehouseInventoryInData.unit}}</span>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submit">提交</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {warehouseInventoryOutSaveApi, warehouseInventoryOutInfoApi} from '@/api/warehouse/warehouseInventoryOut'
import {warehouseInventoryInAllApi} from "@/api/warehouse/warehouseInventoryIn";
import {warehouseAllApi} from "@/api/warehouse/warehouse";

export default {
  name: 'warehouseInventoryOutEdit',
  data() {
    return {
      formData: {
        warehouse_inventory_out_id: 0,
        type: 2,
        warehouse_id: '0',
        warehouse_inventory_in_id: 0,
        out_num: 0,
      },
      warehouseInventoryInData: {
        goods_name: '',
        unit: '',
        num: 0,
      },
      warehouseInventoryInList: [],
      warehouseList: [],
      ruleValidate: {
        type: [
          {required: true, type: 'number', message: '请选择出库类型', trigger: 'change'}
        ],
        warehouse_id: [
          {required: true, message: '请选择出库仓库', trigger: 'change'}
        ],
        warehouse_inventory_in_id: [
          {required: true, type: 'number', message: '请选择入库单', trigger: 'change'}
        ],
        out_num: [],
      },
    }
  },
  mounted() {
    this.loadWarehouseList()
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    //提交数据
    submit() {
      // 验证数据
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          this.$Message.error('请检查输入内容!')
          return false
        } else {
          //请求接口
          warehouseInventoryOutSaveApi(this.formData).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })

    },

    // 编辑加载数据
    loadFormData(id) {
      warehouseInventoryOutInfoApi(id).then(res => {
        //数据赋值
        this.formData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 选择出库类型
    selectType(){
      this.formData.warehouse_id = ''
      this.formData.warehouse_inventory_in_id = 0
      this.formData.out_num = 0
      this.warehouseInventoryInList = []
      this.warehouseInventoryInData = {
        goods_name: '',
        unit: '',
        num: 0,
      }

      // 根据出库类型动态设置验证规则
      if (this.formData.type === 1) { // 基地出库
        this.ruleValidate.out_num = [
          { required: true, type: 'number', min: 0.01, message: '请输入出库数量', trigger: 'blur' },
        ];
      } else { // 不是基地出库
        this.ruleValidate.out_num = []; // 移除验证规则
      }
    },

    // 加载仓库
    loadWarehouseList() {
      warehouseAllApi().then(res => {
        //数据赋值
        this.warehouseList = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 选择仓库
    selectWarehouse(){
      this.formData.warehouse_inventory_in_id = 0
      this.warehouseInventoryInData = {
        goods_name: '',
        unit: '',
        num: 0,
      }
      this.loadWarehouseInventoryInList()
    },

    // 加载入库单
    loadWarehouseInventoryInList() {
      this.warehouseInventoryInList = []
      if (!this.formData.warehouse_id) {
        return false
      }
      if (!this.formData.type) { // 基地出库
        return false
      }
      warehouseInventoryInAllApi({warehouse_id: this.formData.warehouse_id, type: this.formData.type}).then(res => {
        //数据赋值
        this.warehouseInventoryInList = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 选择入库单
    selectWarehouseInventoryIn(){

      if (this.formData.warehouse_inventory_in_id === 0 || !this.formData.warehouse_inventory_in_id){
        return
      }

      // 把选中的数据赋值
      this.warehouseInventoryInData = this.warehouseInventoryInList.find(item => item.warehouse_inventory_in_id === this.formData.warehouse_inventory_in_id)
      // 如果是三方出库 出库数量=库存数量
      if (this.formData.type === 2) {
        this.formData.out_num = this.warehouseInventoryInData.num
      }else{
        this.formData.out_num = 0
      }
    },



  }
}
</script>
